import dynamic from 'next/dynamic';
import Router from 'next/router';
import React, { ReactNode, useCallback, useEffect, useState } from 'react';

import { isBrowser, isPC } from '~/shared/utils/envUtil';
import {
  clearNotificationsToLocalStorage,
  getNotificationFromLocalStorage,
  Notification,
} from '~/utils/storageUtils';

const Snackbar = dynamic(() => import('shared/components/shared/Snackbar'));

type NotificationData = {
  notification: Notification;
  isPC: boolean;
};

const SnackbarProvider = (props: { children: ReactNode }) => {
  const [notificationData, setNotificationData] = useState<
    NotificationData | undefined
  >(undefined);

  const handleCloseSnackbar = useCallback(() => {
    setNotificationData(undefined);
  }, []);

  const showNotificationIfUpdated = useCallback(() => {
    if (isBrowser) {
      // NOTE: (akutsu) snackbarの表示が必要かローカルストレージをチェックし、値をセットする
      const notifications = getNotificationFromLocalStorage();
      const _isPC = isPC(navigator.userAgent);
      if (notifications.length > 0) {
        setNotificationData({
          notification: notifications[0],
          isPC: _isPC,
        });
        clearNotificationsToLocalStorage();
        setTimeout(() => {
          handleCloseSnackbar();
        }, 6000);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // SPA遷移だとuseEffectが呼ばれないため
  Router.events.on('routeChangeComplete', () => showNotificationIfUpdated());
  // SPA遷移以外での遷移がされたとき
  useEffect(() => {
    showNotificationIfUpdated();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {notificationData &&
        notificationData.notification.title &&
        notificationData.notification.message && (
          <Snackbar
            title={notificationData.notification.title}
            message={notificationData.notification.message}
            isPC={notificationData.isPC}
            onClickClose={handleCloseSnackbar}
          />
        )}
      {props.children}
    </>
  );
};
export default SnackbarProvider;
